export const paidPaymentStatus = 2;
export const creditedPaymentStatus = 4;

export const paidByFileCategory = 1;
export const paidManuallyCategory = 2;
export const paidInCashCategory = 3;
export const creditCategory = 4;



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/invoices/invoice-constants.js
 **/